import { Box, Tab, TabList, Tabs, Tooltip, tabClasses } from "@mui/joy";
import { Building2, Boxes, HardHat } from "lucide-react";
import { SUPPLIER_TYPES } from "../../../../../interfaces";

interface VerticalTabsProps {
    value: string;
    onChange: (value: string) => void;
    supplierType?: string;
}

export function VerticalTabs({ value, onChange, supplierType }: VerticalTabsProps) {
    const showMaterials =
        !supplierType ||
        supplierType === SUPPLIER_TYPES.MANUFACTURER ||
        supplierType === SUPPLIER_TYPES.MANUFACTURER_AND_LABOR;
    const showLabor =
        supplierType === SUPPLIER_TYPES.LABOR ||
        supplierType === SUPPLIER_TYPES.MANUFACTURER_AND_LABOR;

    return (
        <Box
            sx={{
                height: "100%",
                width: 70, // Fixed width for the sidebar
                borderRight: "1px solid",
                borderColor: "divider",
                bgcolor: "background.surface",
                display: "flex",
                flexDirection: "column",
                alignItems: "center", // Center tabs horizontally
                pt: 2,
            }}
        >
            <Tabs
                orientation="vertical"
                value={value}
                onChange={(_, val) => typeof val === "string" && onChange(val)}
                sx={{
                    bgcolor: "transparent",
                    [`& .${tabClasses.root}`]: {
                        minHeight: 48,
                        width: 48, // Square aspect ratio
                        borderRadius: "4px",
                        justifyContent: "center",
                        mb: 1, // Spacing between tabs
                        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",

                        // Hover State
                        "&:hover": {
                            bgcolor: "background.level1",
                        },

                        // Active State (Soft Background)
                        [`&[aria-selected="true"]`]: {
                            bgcolor: "primary.softBg", // The soft background you wanted
                            color: "primary.plainColor", // Matching brand color for icon
                        },
                    },
                }}
            >
                <TabList
                    disableUnderline
                    sx={{
                        flexDirection: "column",
                        gap: 0,
                        p: 0,
                        alignItems: "center",
                    }}
                >
                    <Tooltip title="Details" placement="right" arrow variant="soft" size="md">
                        <Tab value="details" disableIndicator sx={{ p: 1 }}>
                            <Building2 size={18} />
                        </Tab>
                    </Tooltip>

                    {showMaterials && (
                        <Tooltip title="Materials Inventory" placement="right" arrow variant="soft" size="md">
                            <Tab value="inventory" disableIndicator sx={{ p: 1 }}>
                                <Boxes size={18} />
                            </Tab>
                        </Tooltip>
                    )}

                    {showLabor && (
                        <Tooltip title="Labor Rates" placement="right" arrow variant="soft" size="md">
                            <Tab value="labor" disableIndicator sx={{ p: 1 }}>
                                <HardHat size={18} />
                            </Tab>
                        </Tooltip>
                    )}
                </TabList>
            </Tabs>
        </Box>
    );
}
